import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/calculations`;

export const calculationService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.formula_type) params.append('formula_type', filters.formula_type);
    if (filters.search) params.append('search', filters.search);
    if (filters.method_type_id) params.append('method_type_id', filters.method_type_id);
    const response = await axios.get(`${API_BASE}?${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  getTypes: async () => {
    const response = await axios.get(`${API_BASE}/types`);
    return response.data;
  }
};

export default calculationService;
